import { Model, Attr, HasMany } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'

@Model()
export default class Region extends ApplicationRecord {
  static jsonapiType = 'regions'

  @Attr() id!: string
  @Attr() name!: string
  @Attr() code!: string
  @Attr() codeAlias!: string
  @Attr() createdAt!: string
  @Attr() updatedAt!: string

  @HasMany('countries') countries!: any[]
  @HasMany('gift_cards') giftCards!: any[]
}
